import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
export const LabelAndValue = ({ label, value }) => (_jsxs(Stack, { children: [_jsx(Typography, { children: label }), _jsx(Typography, { component: "span", color: "GrayText", whiteSpace: "pre-line", children: value })] }));
